import { isRunningInIframe } from '../isRunningInIframe/isRunningInIframe';
import { BOOKINGS_APP_DEF_ID } from '../const';
export async function isBookingsSectionInstalled(wixCodeApi, sectionId) {
  if (isRunningInIframe()) {
    return new Promise(resolve => {
      window.Wix.isAppSectionInstalled(sectionId, {
        appDefinitionId: BOOKINGS_APP_DEF_ID
      }, isInstalled => {
        resolve(isInstalled);
      });
    });
  }
  return Promise.resolve(wixCodeApi.site.isAppSectionInstalled({
    sectionId,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  }));
}
//# sourceMappingURL=isBookingsSectionInstalled.js.map